module.exports = __webpack_public_path__ + "img/layout-board.24c87231.svg";